const WHOLE_DOLLARS = new Intl.NumberFormat(undefined, {
  style: "currency",
  currency: "USD",
  maximumFractionDigits: 0,
});

const COMPACT_DOLLARS = new Intl.NumberFormat(undefined, {
  style: "currency",
  currency: "USD",
  notation: "compact",
  maximumFractionDigits: 1,
});

/** Whole dollars from cents, the way a person says it: "$12,400". */
export function dollars(cents: number): string {
  return WHOLE_DOLLARS.format(cents / 100);
}

/** The short form for a tile or an axis: "$12.4K". */
export function compactDollars(cents: number): string {
  return COMPACT_DOLLARS.format(cents / 100);
}

export function percent(value: number): string {
  return `${Number.isInteger(value) ? value : value.toFixed(1)}%`;
}

/** "1 dose", "3 doses". */
export function plural(count: number, one: string, many = `${one}s`): string {
  return `${count} ${count === 1 ? one : many}`;
}

/** A YYYY-MM-DD day as "Sep 29", read as the calendar day it names, not as UTC midnight. */
export function dayLabel(day: string): string {
  const [year, month, date] = day.split("-").map(Number) as [number, number, number];
  return new Date(year, month - 1, date).toLocaleDateString(undefined, {
    month: "short",
    day: "numeric",
  });
}

/** A YYYY-MM month as "Sep". */
export function monthLabel(month: string): string {
  const [year, index] = month.split("-").map(Number) as [number, number];
  return new Date(year, index - 1, 1).toLocaleDateString(undefined, { month: "short" });
}

/** An axis tick for a count: a quiet day scales the axis to halves, and half an incident is not a
 * thing. */
export function wholeTick(value: string): string {
  return Number.isInteger(Number(value)) ? value : "";
}
